<template>
  <gh-tabs-page v-model="tabIndex" :tabs="tabs" :show-tabs="true">
    <template #page-0="{tab,active}">
      <gh-table-page ref="table" :show-tabs="false" :args-query="args" module="mes.business.sys.chart.service"
        cls="ChartService" :before-save="beforeSave" @viewItem="viewItem">
        <template #area_query>
          <v-layout row align-center>
            <v-flex xl6 md3>
              <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
                append-icon="mdi-circle-edit-outline">
              </v-text-field>

            </v-flex>
            <!-- {{TestValue}} -->
            <font color="primary">颜色测试</font>
            <!-- <v-card-title color="primary">
              title
            </v-card-title> -->
            <span class="primary">颜色测试</span>
          </v-layout>
        </template>
        <template #area_detail="{current}">
          <span></span>
        </template>
      </gh-table-page>
    </template>
    <template #page-1="{tab,active}">
      <gh-table-page ref="detail_table" :tabs="detailTabs" :show-tabs="false" :args-query="detailArgs" module="chart"
        :cls="cls" :before-save="beforeDetailSave">
        <template #area_left>
          <v-container grid-list-xs>

            <gh-business-tree ref="tree" v-model="selectedNode" module="mes.business.sys.chart.service"
              cls="TemplateManager" :showToolbar="false" :accordion="false" :draggable="false"
              :expand-on-click-node="false" :default-expand-all="true">
              <template v-slot="{node,data}">
                <span>{{data.Ctrl}}|{{data.Name}}</span>
              </template>
            </gh-business-tree>

          </v-container>

        </template>
        <template #area_query>
          <v-layout row align-center>
            <!-- <v-flex>
              <v-text-field v-model="keyword" counter :autofocus="true" clearable label="关键字"
                append-icon="mdi-circle-edit-outline" @change="">
              </v-text-field>
            </v-flex> -->
          </v-layout>
        </template>
      </gh-table-page>


      <!-- <gh-page :drawer="active===1">
        <template #left-drawer>
          <gh-business-tree ref="tree" v-model="selectedNode" module="mes.business.sys.chart.service"
            cls="TemplateManager" :showToolbar="false" :accordion="false" :draggable="false"
            :expand-on-click-node="false" :default-expand-all="true">
            <template v-slot="{node,data}">
              <span>{{data.Ctrl}}|{{data.Name}}</span>
            </template>
          </gh-business-tree>
        </template>
        <template #toolbar>
        </template>
        <gh-table ref="table" :props="props" @copyItem="" @editItem="" @deleteItem="">
          <template slot="title">
          </template>
          <template slot="title-operation">
          </template>
          <template slot-scope="{props}" slot="">
            <td></td>
          </template>
        </gh-table> -->
      </gh-page>
    </template>
  </gh-tabs-page>


</template>

<style scoped>

</style>

<script>
  import Charts from "./charts.ts";
  export default Charts;
</script>